import allMakesEn from './all-makes-en.json';
import allMakesFr from './all-makes-fr.json';

export const ALL_MAKES = {
  'en-CA': allMakesEn,
  'fr-CA': allMakesFr,
};
